
import { uiToastsEnabled, isSuppressableToastType } from '@/utils/uiToasts'

export const generalStore = {
    // This makes your getters, mutations, and actions accessed by, eg: 'userStore/{name}' instead of mounting getters, mutations, and actions to the root namespace.
    namespaced: true,

    state: {
      toastData: false,
      device: 'laptop'
    },


    getters: {},


    actions: {
        showToast({ commit, state, rootState }, { type, icon, text }) {
            // Users can switch the corner confirmations off under their
            // profile. Errors and warnings ignore the setting — see
            // utils/uiToasts.js.
            if (isSuppressableToastType(type) && !uiToastsEnabled(rootState.userStore?.user_settings)) return

            commit('SET_TOAST_DATA', { type, icon, text })
        },
        clearToast({ commit, state }) {
            commit('CLEAR_TOAST_DATA')
        },
        setCurrentDevice({ commit, state }, data) {
            if(state.device === data) return 0
            commit('SET_CURRENT_DEVICE', data)
        }

    },


    mutations: {
        SET_TOAST_DATA: (state, data) => {
            state.toastData = data
        },
        CLEAR_TOAST_DATA: (state) => {
            state.toastData = false
        },
        SET_CURRENT_DEVICE: (state, data) => {
            state.device = data
        }
    }
}
